import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { InlineInputGroup, Input } from 'barnyard/components';
import RuleForm from '../inputs/RuleForm';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const BillMismatchRule = (props) => {
  const {
    form, type, onSubmit, initialValues, ...other
  } = props;
  const [supplier, setSupplier] = useState(initialValues.supplier || []);
  const [address_street, setAddress] = useState(initialValues.address_street || '');
  const [zip_code, setZipCode] = useState(initialValues.zip_code || '');
  const [regions, setRegions] = useState(
    !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
  );

  const submit = (event) => {
    event.preventDefault();
    onSubmit({
      kind: 'bill_to_mismatch',
      regions: _.filter(regions),
      value: {
        supplier,
        address_street,
        zip_code
      }
    });
  };

  const onReset = () => {
    setSupplier(initialValues.supplier || []);
    setAddress(initialValues.address_street || '');
    setZipCode(initialValues.zip_code || '');
    setRegions(
      !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
    );
  };


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        value={regions}
        onChange={setRegions}
      />
      <InlineSupplierSelect
        value={supplier}
        label='Supplier'
        description='Supplier to be included'
        onChange={setSupplier}
        placeholder='Select a supplier...'
        include_all={false}
      />
      <InlineInputGroup
        label='Address Line 1'
        description='Enter street address'
        InputComponent={Input}
        value={address_street}
        onChange={setAddress}
      />
      <InlineInputGroup
        label='Zip Code'
        description='Enter zip code'
        value={zip_code}
        InputComponent={Input}
        onChange={setZipCode}
      />
    </RuleForm>
  );
};

BillMismatchRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

BillMismatchRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default BillMismatchRule;
